// Generated by purs version 0.13.0
"use strict";
var Chip_Model_State = require("../Chip.Model.State/index.js");
var notDead = function (game) {
    if (game.state instanceof Chip_Model_State.Dead) {
        return false;
    };
    return true;
};
module.exports = {
    notDead: notDead
};
